module.exports = __webpack_public_path__ + "media/images/new-ui-images/icon-4-9448b9c3f33c5aa06407f01aa2fe68d0.svg";